import { render, staticRenderFns } from "./c7CustomerChat.vue?vue&type=template&id=afbee178"
import script from "./c7CustomerChat.vue?vue&type=script&lang=js"
export * from "./c7CustomerChat.vue?vue&type=script&lang=js"
import style0 from "./c7CustomerChat.vue?vue&type=style&index=0&id=afbee178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports